"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeFiltersWithDashboard = exports.defaultDashboardThemeModifier = exports.DashboardView = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var DashboardViewErrorBoundary_1 = require("./DashboardViewErrorBoundary");
Object.defineProperty(exports, "DashboardView", { enumerable: true, get: function () { return DashboardViewErrorBoundary_1.DashboardViewErrorBoundary; } });
var defaultDashboardThemeModifier_1 = require("./defaultDashboardThemeModifier");
Object.defineProperty(exports, "defaultDashboardThemeModifier", { enumerable: true, get: function () { return defaultDashboardThemeModifier_1.defaultDashboardThemeModifier; } });
var mergeFiltersWithDashboard_1 = require("./mergeFiltersWithDashboard");
Object.defineProperty(exports, "mergeFiltersWithDashboard", { enumerable: true, get: function () { return mergeFiltersWithDashboard_1.mergeFiltersWithDashboard; } });
tslib_1.__exportStar(require("./types"), exports);
tslib_1.__exportStar(require("./hooks"), exports);
//# sourceMappingURL=index.js.map